import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { HttpUrlGenerator } from '@ngrx/data';
import { Update } from '@ngrx/entity';
import { TeamInterface } from '@shared/api';
import { isNumber } from 'lodash-es';
import { map, Observable } from 'rxjs';
import { CustomDefaultDataService } from '../custom-default-data-service.class';
import { EntityTypeEnum } from '../index';

@Injectable({ providedIn: 'root' })
export class TeamsDataService extends CustomDefaultDataService<TeamInterface> {
  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super(EntityTypeEnum.Team, http, httpUrlGenerator);
  }

  override add(entity: TeamInterface): Observable<TeamInterface> {
    return this.http.post<TeamInterface>(this.entitiesUrl, {
      name: entity.name,
    });
  }

  override update(update: Update<TeamInterface>): Observable<TeamInterface> {
    return this.http.patch<TeamInterface>(
      `${this.entityUrl}${update.id}`,
      update.changes,
    );
  }

  override delete(key: number | string): Observable<number | string> {
    return this.http
      .post(`${this.entitiesUrl}/delete`, {
        teamGuids: isNumber(key)
          ? [key]
          : key.split(',').length > 0
            ? key.split(',')
            : [key],
      })
      .pipe(map(() => key));
  }
}
